import "./globals.css";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { initSentry } from "./sentry/init-sentry";

initSentry();

if (import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN) {
	posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
		api_host: "https://eu.i.posthog.com",
		defaults: "2026-01-30",
	});
}

const mq = window.matchMedia("(prefers-color-scheme: dark)");
const applyTheme = (dark: boolean) => {
	document.documentElement.classList.toggle("dark", dark);
};
document.documentElement.classList.add("antialiased");
applyTheme(mq.matches);
mq.addEventListener("change", (e) => applyTheme(e.matches));

const root = document.getElementById("root");

if (!root) throw new Error("Root element not found");

createRoot(root).render(
	<PostHogProvider client={posthog}>
		<App />
	</PostHogProvider>,
);
